<template>
    <div :class="$style['order-states-step']">
        <el-steps :active="active" :align-center="alignCenter">
            <el-step v-for="(item,index) in steps" :key="index" :title="item[stepTitle]" :description="item[description]">
                <slot name="icon"/>
                <slot name="title"/>
                <slot name="description"/>
            </el-step>
        </el-steps>
    </div>
</template>
<script>// 组件class前缀
const prefixCls = 'order-states-step'
export default {
  name: 'wt-steps',
  props: {
    alignCenter: {
      type: Boolean,
      default: false
    },
    active: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      default: function () {
        return []// 数组中包含title、description和icon三个字段
      }
    },
    stepTitle: {
      type: String,
      default: 'title'
    },
    description: {
      type: String,
      default: 'description'
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>
<style module lang="less" >
@import '~less/var.less';
.order-states-step{
    :global
    .el-step__title{
        font-size:15px;
    }
    :global
    .el-step.is-horizontal{
         .el-step__icon{
            height: 40px;
            width: 40px;
        }
        .el-step__line{
            top: 19px;
        }
    }
    :global
    .el-step__head{
      .el-step__icon{
            background-color: @stepDeefaultBackgroud;
            color: #fff;
        }
    }
    :global
    .el-step__head.is-process{
        border-color: #c0c4cc;

    }
    :global
    .el-step__title.is-process{
        color: #c0c4cc;
        font-weight:normal
    }
    :global
    .el-step__head.is-finish{
        .el-step__icon{
            background-color: @mainColor;
            color: #fff;

        }
    }
}
</style>
